import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import {
  ListingBrokers,
  ListingDescription,
  ListingFiles,
  ListingParcelData,
  ListingSpaces,
} from '~/components/listing'
import { cn } from '~/lib'
import type { Client, Listing } from '~/models'

export default function ListingTabs({
  client,
  listing,
}: {
  client: Client
  listing: Listing
}) {
  const location = useLocation()

  const [currentTab, setCurrentTab] = useState<number>(0)

  useEffect(() => {
    setCurrentTab(0)
  }, [location.pathname])

  const tabs: { name: string; count?: number; component: React.ReactNode }[] = [
    {
      name: 'Overview',
      component: <ListingDescription listing={listing} />,
    },
  ]
  if (listing.files.length > 0) {
    tabs.push({
      name: 'Files',
      count: listing.files.length,
      component: <ListingFiles listing={listing} />,
    })
  }
  if (listing.suites.length > 1) {
    tabs.push({
      name: 'Spaces',
      count: listing.suites.length,
      component: <ListingSpaces listing={listing} />,
    })
  }
  if (listing.profiles.length > 0 || client.contact) {
    tabs.push({
      name:
        listing.profiles.length > 1 ||
        (listing.profiles.length > 0 && client.contact)
          ? 'Contacts'
          : 'Contact',
      count: listing.profiles.length + (client.contact ? 1 : 0),
      component: <ListingBrokers client={client} listing={listing} />,
    })
  }
  if (client.parcel_data_enabled) {
    tabs.push({
      name: 'Parcel',
      component: <ListingParcelData listing={listing} />,
    })
  }
  return (
    <div>
      <div className="-ml-4 -mr-4 block bg-muted bg-opacity-20 px-4 py-2 sm:-ml-6 sm:-mr-6">
        <nav
          className="flex space-x-2 overflow-x-auto lg:space-x-4"
          aria-label="Tabs">
          {tabs.map((tab, index) => (
            <button
              key={tab.name}
              onClick={() => setCurrentTab(index)}
              className={cn(
                'relative flex items-center rounded-md px-1.5 py-0 text-base font-medium leading-[30px] sm:px-2',
                index === currentTab
                  ? 'bg-primary text-secondary dark:text-foreground'
                  : 'text-muted-foreground hover:bg-background/50 hover:text-muted-foreground'
              )}>
              <span>{tab.name}</span>
              {tab.count && (
                <span className="ml-1 rounded-full bg-background px-[6px] text-sm text-foreground sm:block">
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
      <div className="pt-4">
        {tabs[currentTab] ? tabs[currentTab].component : tabs[0].component}
      </div>
    </div>
  )
}
